import { createAction, props } from '@ngrx/store';
import { Leader, LeaderCategory } from '../../core/models/leader.model';

// Load all leaders
export const loadLeaders = createAction('[Leaders] Load Leaders');
export const loadLeadersSuccess = createAction('[Leaders] Load Leaders Success', props<{ leaders: Leader[] }>());
export const loadLeadersFailure = createAction('[Leaders] Load Leaders Failure', props<{ error: string }>());

// Load by category
export const loadLeadersByCategory = createAction(
  '[Leaders] Load By Category',
  props<{ category: LeaderCategory }>()
);
export const loadLeadersByCategorySuccess = createAction(
  '[Leaders] Load By Category Success',
  props<{ category: LeaderCategory; leaders: Leader[] }>()
);

// Load featured
export const loadFeaturedLeaders = createAction('[Leaders] Load Featured');
export const loadFeaturedLeadersSuccess = createAction(
  '[Leaders] Load Featured Success',
  props<{ leaders: Leader[] }>()
);

// Select a leader
export const selectLeader = createAction('[Leaders] Select Leader', props<{ leaderId: string }>());
export const clearSelectedLeader = createAction('[Leaders] Clear Selected');

// Bookmarks
export const toggleBookmark = createAction('[Leaders] Toggle Bookmark', props<{ leaderId: string }>());
export const setBookmarks = createAction('[Leaders] Set Bookmarks', props<{ leaderIds: string[] }>());

// Filter/sort UI state
export const setSearchQuery = createAction('[Leaders] Set Search Query', props<{ query: string }>());
export const setCategoryFilter = createAction(
  '[Leaders] Set Category Filter',
  props<{ category: LeaderCategory | null }>()
);
export const invalidateCache = createAction('[Leaders] Invalidate Cache');
